import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const state = {
  size: {width: 0, height: 0},
  roomOptions: [],
  objects: [],
  availableFilters: {},
  availableLighters: {},
  activeFilters: [],
  activeLighter: null,
  filters: {'rooms': []},
  lit: false
}

function filterByRooms (list, rooms) {
  if (!rooms.length) {
    return list
  }

  return list.map((obj) => {
    obj.disabled = rooms.indexOf(obj.data['rooms']) === -1
    return obj
  })
}

function applyObjectFilter (obj, field, operator, value) {
  let objValue

  if (field === 'status') {
    objValue = obj.status
  } else {
    objValue = obj.data[field]
  }

  if (operator === '=') {
    return objValue === value
  } else if (operator === '<') {
    return objValue < value
  } else if (operator === '>') {
    return objValue > value
  }

  return false
}

function applyObjectLighter (obj, field, operator, value) {
  let objValue

  if (field === 'status') {
    objValue = obj.status
  } else {
    objValue = obj.data[field]
  }

  if (operator === '=') {
    return objValue === value
  } else if (operator === '<') {
    return objValue < value
  } else if (operator === '>') {
    return objValue > value
  }

  return false
}

function applyLighters (objects) {
  if (!state.activeLighter) {
    return objects.map(obj => {
      obj.lit = false
      return obj
    })
  }

  // const lighter = state.availableLighters[state.activeLighter]

  const lighter = state.availableLighters.find(l => l.filter.key === state.activeLighter)

  if (!lighter) return

  return objects.map((obj) => {
    if (!lighter.filter.field) {
      obj.lit = true
    } else {
      obj.lit = applyObjectLighter(obj, lighter.filter.field, lighter.filter.operator, lighter.filter.value)
    }
    return obj
  })
}

function applyFilters (objects) {
  const activeFilters = Object.keys(state.availableFilters).map(k => {
    return state.availableFilters[k]
  }).filter(f => f.active)

  if (!activeFilters.length) {
    return objects
  }

  return objects.map((obj) => {
    if (obj.disabled) {
      return obj
    }
    for (let i = 0; i < activeFilters.length; i++) {
      const filter = activeFilters[i]

      if (!applyObjectFilter(obj, filter.filter.field, filter.filter.operator, filter.filter.value)) {
        obj.disabled = true
      }
    }
    return obj
  })
  /* let c = objects.filter((obj) => {
    for (let i = 0; i < activeFilters.length; i++) {
      const filter = activeFilters[i]

      if (!applyObjectFilter(obj, filter.field, filter.operator, filter.value)) {
        return false
      }
    }
    return true
  })
  return c */
}

const getters = {
  getObjects () {
    return applyLighters(applyFilters(filterByRooms(state.objects, state.filters.rooms)))
  },
  getObject () {
    const obj = applyLighters(applyFilters(filterByRooms(state.objects, state.filters.rooms)))

    return (id) => {
      return obj.find(obj => {
        return obj.id === id
      })
    }
  },
  getAvailableFilters () {
    return state.availableFilters
  },
  getAvailableLighters () {
    return state.availableLighters
  },
  getActiveLighter () {
    return state.activeLighter
  },
  getSize () {

  },
  isLit () {
    return state.lit
  }
}

const mutations = {
  setMainSize (state, sizes) {
    state.size = {
      width: sizes[0],
      height: sizes[1]
    }
  },
  toggleShowAll (state, toggle) {
    state.lit = !state.lit
  },
  toggleFilter (state, filter) {
    state.availableFilters[filter].active = !state.availableFilters[filter].active
  },
  setAvailableLighters (state, lighters) {
    state.availableLighters = lighters
  },
  toggleLighter (state, lighter) {
    if (state.activeLighter === lighter) {
      state.activeLighter = null
    } else {
      state.activeLighter = lighter
    }
  },
  setAvailableFilters (state, filters) {
    state.availableFilters = filters
  },
  setObjects (state, objects) {
    state.objects = objects
  },
  setRoomOptions (state, opts) {
    state.roomOptions = opts
    state.filters['rooms'] = [].concat(opts)
  },
  toggleRoom (state, room) {
    let idx = state.filters['rooms'].indexOf(room)

    if (idx > -1) {
      state.filters['rooms'].splice(idx, 1)
    } else {
      state.filters['rooms'].push(room)
    }
  }
}

export default new Vuex.Store({
  state,
  getters,
  mutations
})



// WEBPACK FOOTER //
// ./src/filter.js